<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
	    <zestawieniaMenu />
	    <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Lista użytkowników i godziny pracy za okres: {{ formattedMonth }}</h4>
            </div>
          </div>
        </div>

        <div class="widget-content">
	     <div class="row col-12 mb-3">
          <div class="col-auto d-flex mb-3">
            <label for="monthSelect" class="me-2">Miesiąc:</label>
            <select id="monthSelect" v-model="selectedMonth" class="form-select form-select-sm w-100" @change="loadSelectedPeriod">
              <option v-for="(month, index) in monthNames" :key="index" :value="index">
                {{ month }}
              </option>
            </select>
          </div>
          <div class="col-auto mx-2 d-flex mb-3">
            <label for="yearSelect" class="me-2">Rok:</label>
            <select id="yearSelect" v-model="selectedYear" class="form-select form-select-sm w-100" @change="loadSelectedPeriod">
              <option v-for="year in yearRange" :key="year" :value="year">
                {{ year }}
              </option>
            </select>
          </div>

		  <div class="table-responsive mt-3">
			<table class="table table-bordered table-hover">
			  <thead>
				<tr>
				  <th style="text-align: left;">Imię i nazwisko</th>
				  <th style="text-align: right;">Projekt</th>
				  <th style="text-align: right;">Suma godzin</th>
				  <th style="text-align: center;">Akcje</th>
				</tr>
			  </thead>
			  <tbody>
				<tr v-for="user in userList" :key="user.id">
				  <td style="text-align: left;">{{ user.firstName }} {{ user.lastName }}</td>
				  <td style="text-align: right;">
					<div v-for="(project, projectNumber) in user.projectSummary" :key="projectNumber">
					  {{ projectNumber }}
					</div>
				  </td>
				  <td style="text-align: right;">
					<div v-for="(project, projectNumber) in user.projectSummary" :key="projectNumber">
					  {{ project.hours }}h {{ project.minutes }}m
					</div>
					 <label class="ms-2"><strong v-if="user.totalTime && user.totalTime !== '0h 0m'">Razem: {{ user.totalTime }}</strong></label>
				  </td>
				  <td style="text-align: center;">
					<div style="display: flex; flex-wrap: wrap; gap: 0.5rem; justify-content: center;margin-bottom: 0.5rem;">
						<a :href="route('worktime-users.generateUserPdfWorkHoursP', { year: selectedYear, month: selectedMonth + 1, id: user.id })"
						   class="btn btn-outline-info btn-sm equal-width-btn">
						  <i class="bi bi-file-earmark-pdf"></i>&nbsp;Pobierz podsumowanie
						</a>
						<a :href="route('worktime-users.viewUserPdfWorkHoursP', { year: selectedYear, month: selectedMonth + 1, id: user.id })"
						   rel="noopener noreferrer" target="_blank" class="btn btn-outline-info btn-sm equal-width-btn">
						  <i class="bi bi-eye"></i>&nbsp;Podgląd podsumowania
						</a>
					</div>
				   <div style="display: flex; flex-wrap: wrap; gap: 0.5rem; justify-content: center;">
					
					<a :href="route('worktime.office.show', { year: selectedYear, month: selectedMonth + 1, id: user.id })"
					   class="btn btn-info btn-sm equal-width-btn">
					  <i class="bi bi-url"></i>&nbsp;Przejdź
					</a>
					<button class="btn btn-sm equal-width-btn"
							:class="user.locked ? 'btn-success' : 'btn-danger'"
							@click="toggleLockPeriod(user)">
					  {{ user.locked ? 'Odblokuj okres' : 'Zablokuj okres' }}
					</button>
				   </div>
				  </td>
				</tr>
			  </tbody>
			</table>
		  </div>
	    </div> </div>
	  </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import { useForm, router } from "@inertiajs/vue3";
import { defineProps, defineComponent, ref, computed } from "vue";
import route from "../../../../../vendor/tightenco/ziggy/src/js/index.js";
import zestawieniaMenu from "@/Pages/Kadry/parts/zestawieniaMenu.vue";
import axios from "axios";

export default defineComponent({
  components: { AppLayout, zestawieniaMenu },
  props: {
    users: Array,
    year: Number,
    month: Number, 
  },
  setup(props) {
    const monthNames = [
      "Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec",
      "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"
    ];

    const selectedMonth = ref(props.month - 1);
    const selectedYear = ref(props.year);

    const mapUsers = (usersData) => {
      return usersData.map(user => {
        let projectSummary = {};

        if (Array.isArray(user.workHours)) {
          user.workHours.forEach(workHour => {
            const projectNumber = String(workHour.project_number ?? 'Brak projektu');
            const [h, m] = (workHour.hours || '00:00').split(':').map(Number);
			const diffMinutes = h * 60 + m;

            if (!projectSummary[projectNumber]) {
              projectSummary[projectNumber] = { hours: 0, minutes: 0 };
            }
            projectSummary[projectNumber].hours += Math.floor(diffMinutes / 60);
            projectSummary[projectNumber].minutes += diffMinutes % 60;

            if (projectSummary[projectNumber].minutes >= 60) {
              projectSummary[projectNumber].hours += Math.floor(projectSummary[projectNumber].minutes / 60);
              projectSummary[projectNumber].minutes = projectSummary[projectNumber].minutes % 60;
            }
          });
        }

        return {
          ...user,
          projectSummary,
          locked: user.locked ?? false,
        };
      });
    };

    const userList = ref(mapUsers(props.users));

    const yearRange = ref(
      Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - 5 + i)
    );

    const formattedMonth = computed(() => `${monthNames[selectedMonth.value]} ${selectedYear.value}`);

const loadSelectedPeriod = async () => {
  const newMonth = selectedMonth.value + 1;
  try {
    router.get(route('worktime.office.index', { year: selectedYear.value, month: newMonth }), {
      preserveState: true,
    });
  } catch (error) {
    console.error("Błąd podczas zmiany miesiąca:", error);
  }
};
	

    const toggleLockPeriod = async (user) => {
      const period = `${selectedYear.value}-${String(selectedMonth.value + 1).padStart(2, '0')}`;
      try {
		const response = await axios.post(route('worktime-users.toggle-lock'), {
		  user_id: user.id,
		  period: period,
		  status: user.locked ? 0 : 1,
		});

		if (response.data.success) {
		  user.locked = !user.locked;
		  
		  const actionMessage = user.locked 
			? 'Dany okres został zablokowany dla wybranego użytkownika.'
			: 'Dany okres został odblokowany dla wybranego użytkownika.';

		  const actionTitle = user.locked ? 'Okres zablokowany' : 'Okres odblokowany';

		  Toast.fire({
			icon: 'success',
			title: actionTitle,
			html: `<strong>${actionMessage}</strong>`,
			timer: 1500,
			timerProgressBar: true,
		  });
		}
      } catch (error) {
        console.error("Błąd podczas zmiany statusu zablokowania okresu:", error);
		 Toast.fire({
      icon: 'error',
      title: 'Błąd zapisu',
      html: '<strong>Nie udało się zablokować okresu.</strong>',
    });
      }
    };
    return {
      selectedMonth,
      selectedYear,
      monthNames,
      yearRange,
      formattedMonth,
      userList,
      loadSelectedPeriod,
      toggleLockPeriod,
    };
  },
  
 methods: {
  
      showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  
 }, 
  
});
</script>

<style scoped>
.container {
  max-width: 100%;
  margin: auto;
}
.table {
  width: 100%;
  border-collapse: collapse;
}
.table-responsive {
  overflow-x: auto;
}
th, td {
  padding: 8px;
  border: 1px solid #ddd;
}
.equal-width-btn {
  width: 200px;
}
</style>
